module.exports = __webpack_public_path__ + "img/Choosing.9bd81308.svg";